import React, { ReactNode, useState } from 'react';

import { Image } from '../../components/Image';
import { Viewer } from '../../components/Viewer';
import { PayFitColor } from '../../types/module';
import { classNames } from '../../utils/style';

import { AccordionElement } from './AccordionElement';
import { ImageProps } from '../../components/Image/types';

export interface BodyProps {
  title: string;
  text?: ReactNode;
  button?: ReactNode;
  image?: ImageProps;
  background?: string;
  onClick?: any;
}

export interface AccordionLayoutProps {
  background?: PayFitColor;
  body?: BodyProps[];
  className?: string;
  imagesOnTheLeft?: boolean;
}

const AccordionWithImage = ({
  background,
  body,
  imagesOnTheLeft,
}: AccordionLayoutProps) => {
  const [isOpen, setIsOpen] = useState(0);
  const [clickedItems, setClickedItems] = useState<number[]>([]);

  const handleClick = (i: number) => {
    setIsOpen(i);
    setClickedItems((prev) => {
      if (clickedItems.includes(i)) {
        return prev;
      }

      return [...prev, i];
    });
  };

  return (
    <div
      className={classNames('flex', imagesOnTheLeft && 'md:flex-row-reverse')}
    >
      <div
        className={classNames(
          'md:w-[356px] lg:w-[400px]',
          imagesOnTheLeft ? 'md:ml-24 lg:ml-56' : 'md:mr-24 lg:mr-56',
        )}
      >
        {body?.map((item, i) => (
          <AccordionElement
            key={i}
            isOpen={isOpen === i}
            setOpen={handleClick}
            onClick={item?.onClick}
            index={i}
            {...item}
          />
        ))}
      </div>
      <Viewer indexSelected={isOpen} way="vertical">
        <Viewer.Content
          background={background || body?.[isOpen]?.background}
          className="hidden md:flex flex-1"
        >
          {body?.map((elt, key) => (
            <Viewer.Element key={key} index={key}>
              <div className="viewerElement lg:max-w-[500px]">
                {elt?.image && (
                  <Image
                    {...elt?.image}
                    sizes={[
                      '(min-width: 768px) 350px',
                      '(max-width: 1240px) 600px',
                      '500px',
                    ]}
                    pixelDensity="image_with_text"
                  />
                )}
              </div>
            </Viewer.Element>
          ))}
        </Viewer.Content>
      </Viewer>
    </div>
  );
};

export { AccordionElement, AccordionWithImage };
